(()=>{
const init=()=>{
 document.querySelectorAll('[data-nl-refinement]').forEach(s=>{if(s.dataset.nlReady)return;s.dataset.nlReady='true';s.addEventListener('change',()=>s.closest('form').requestSubmit())});
 document.querySelectorAll('[data-nl-department]').forEach(select=>{
  if(select.dataset.nlReady)return;
  select.dataset.nlReady='true';
  const query=new URLSearchParams(location.search).get('q')||'';
  const selected=Array.from(select.options).find(o=>o.value&&query.startsWith(o.value+' AND '));
  if(selected)select.value=selected.value;
  const form=select.closest('form');
  select.addEventListener('change',()=>{
   if(form.classList.contains('productgrid--search-form')){form.dataset.nlDepartmentChanged='true';form.querySelectorAll('[data-nl-refinement]').forEach(s=>{s.value=''});form.requestSubmit();}
  });
  form.addEventListener('submit',event=>{
   event.preventDefault();event.stopImmediatePropagation();
   const url=new URL(form.action,location.origin);
   const term=form.querySelector('[name="q"]').value.trim();
   url.searchParams.set('type','product');
   url.searchParams.set('q',(select.value?select.value+' AND ':'')+term);
   new FormData(form).forEach((value,key)=>{if(key!=='q'&&key!=='type'&&value)url.searchParams.append(key,value)});
   if(form.dataset.nlDepartmentChanged!=='true')new URLSearchParams(location.search).forEach((value,key)=>{if(key.startsWith('filter.')&&value&&!Array.from(form.elements).some(e=>e.name===key))url.searchParams.append(key,value)});
   location.assign(url.toString());
  },true);
 });
};
if(document.readyState==='complete')init();else window.addEventListener('load',init,{once:true});
document.addEventListener('shopify:section:load',init);
})();
